<template>
  <div class="pt-5">
    <div class="col-sm-12 container-fluid">
      <div class="row">
        <h2 class="m-2">Media Library</h2>
        <div class="col-xl-3 box-col-6 pe-0">
          <div class="md-sidebar">
            <a
              class="btn btn-primary md-sidebar-toggle"
              href="javascript:void(0)"
              @click="collapse()"
              >file filter</a
            >
            <div
              class="md-sidebar-aside job-left-aside custom-scrollbar"
              :class="filtered ? 'open' : ''"
            >
              <SideBarCard :clickMore="clickMore" />
            </div>
          </div>
        </div>

        <div class="col-xl-9 col-md-12 box-col-12">
          <div id="mediaLibrary" class="card">
            <div class="card-body">
              <div class="mediaBtns">
                <button
                  class="addBtn"
                  data-bs-toggle="modal"
                  data-bs-target="#addFolder"
                >
                  Add New Folder
                </button>
                <button
                  class="uploadBtn"
                  data-bs-toggle="modal"
                  data-bs-target="#editModal"
                >
                  Upload
                </button>
              </div>

              <div class="card-body">
                <div class="uploaded_photos">
                  <div class="section-one">
                    <div class="form-inline">
                      <div
                        class="form-group"
                        style="position: relative; width: 300px"
                      >
                        <input
                          class="form-control"
                          type="search"
                          placeholder="Search..."
                          style="padding-left: 40px"
                          @keyup="handleSearch"
                        />
                        <i
                          class="fa fa-search"
                          style="
                            position: absolute;
                            top: 50%;
                            left: 10px;
                            transform: translateY(-50%);
                          "
                        ></i>
                      </div>
                    </div>

                    <div class="form-group m-0" style="width: 250px">
                      <select
                        class="form-select"
                        id="validationCustom04"
                        v-model="selectedSort"
                        @change="handleSortChange"
                      >
                        <option selected="" disabled="" value="">Sort</option>
                        <option value="date.asc">Oldest</option>
                        <option value="date.desc">Newest</option>
                        <option value="name.asc">A-Z</option>
                        <option value="name.desc">Z-A</option>
                      </select>
                    </div>
                  </div>

                  <!-- folders -->
                  <div v-if="media_folders.length > 0" class="my-3">
                    <div class="d-flex justify-content-between p-2">
                      Folders
                      <button @click="clickMore('Folders')">More</button>
                    </div>
                    <div class="folder">
                      <div
                        class="bg-light text-black d-flex flex-row"
                        v-for="(folder, index) in media_folders"
                        :key="index"
                      >
                        <button
                          @click="onFolderClick(folder.id)"
                          style="text-align: left"
                          class="folder_section"
                        >
                          <div>
                            <i
                              class="fa fa-folder"
                              style="color: #ffbc0d; font-size: 3em"
                            ></i>
                          </div>
                          <div>
                            <div>
                              <b>{{ folder.name }}</b>
                            </div>
                            <span class="files_details"
                              >{{ folder.galleries.length }} Files,
                              {{ folder.total_size }}</span
                            >
                          </div>
                        </button>
                        <div class="dropdown-basic">
                          <div class="dropdown">
                            <button type="button" class="float-right dropbtn">
                              <span class="fa fa-ellipsis-v text-black"></span>
                            </button>
                            <div class="dropdown-content">
                              <button
                                class="renameBtn btn"
                                data-bs-toggle="modal"
                                data-bs-target="#renameModal"
                                @click="openRenameModal(index)"
                              >
                                <span class="fa fa-edit text-black pr-2"></span
                                >Rename
                              </button>
                            </div>
                          </div>
                        </div>

                        <!-- rename modal -->
                        <Modal
                          :modalTitle="'Rename Folder'"
                          :modalSize="'modal-lg'"
                          :id="'renameModal'"
                        >
                          <div class="card text-dark">
                            <div class="card-body">
                              <label class="col-form-label">Folder Name</label>
                              <input
                                type="text"
                                class="form-control"
                                v-model="folderNameInput"
                              />

                              <button
                                class="btn btn-warning mt-2 float-right"
                                type="submit"
                                @click.prevent="
                                  renameFolder(
                                    folderToRenameIndex,
                                    folderNameInput
                                  )
                                "
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </Modal>
                      </div>
                    </div>
                  </div>

                  <!-- Folder galleries  -->
                  <div v-if="folder_galleries.length > 0">
                    <div class="folder">
                      <div
                        class="photo_section bg-light text-dark"
                        v-for="(gallery, index) in folder_galleries"
                        :key="index"
                      >
                        <div
                          class="img_section"
                          v-if="gallery.file_type !== 'application/pdf'" style="width: 190px; height: 120px; overflow: hidden; position: relative;"
                        >
                          <img
                            :src="gallery.image_thumb_url"
                            style="object-fit: cover;"
                          />
                        </div>
                        <div
                          class="img_section"
                          v-if="gallery.file_type === 'application/pdf'"
                        >
                          <i
                            class="fa fa-file-text-o"
                            style="
                              font-size: 3em;
                              color: #ffbc0d;
                              padding: 30px;
                            "
                          ></i>
                        </div>
                        <b style="word-wrap: break-word; width: 190px">{{
                          gallery.name
                        }}</b>
                        <span>{{ gallery.file_size }}</span>
                        <span><b>Created At:</b> {{ gallery.created_at }}</span>
                      </div>
                    </div>
                  </div>

                  <!-- Photos -->
                  <div v-if="media_photos.length > 0" class="my-5">
                    <div class="d-flex justify-content-between flex-wrap p-2">
                      Photos
                      <button @click="clickMore('Photos')">More</button>
                    </div>
                    <div class="folder">
                      <div
                        class="photo_section bg-light text-dark"
                        v-for="(photo, index) in media_photos"
                        :key="index"
                      >
                        <div
                          class="img_section"
                          v-if="photo.file_type !== 'application/pdf'" style="width: 190px; height: 120px; overflow: hidden; position: relative;"
                        >
                          <img
                            :src="photo.image_thumb_url"
                            style="object-fit: cover;"
                          />
                        </div>
                        <div
                          class="img_section"
                          v-if="photo.file_type === 'application/pdf'"
                        >
                          <i
                            class="fa fa-file-text-o"
                            style="
                              font-size: 3em;
                              color: #ffbc0d;
                              padding: 30px;
                            "
                          ></i>
                        </div>
                        <b style="word-wrap: break-word; width: 190px">{{
                          photo.name
                        }}</b>
                        <span>{{ photo.file_size }}</span>
                        <span><b>Created At:</b> {{ photo.created_at }}</span>
                      </div>
                    </div>
                  </div>

                  <!-- Videos -->
                  <div class="my-5" v-if="media_videos.length > 0">
                    <div class="d-flex justify-content-between p-2">
                      Videos
                      <button @click="clickMore('Videos')">More</button>
                    </div>
                    <div class="folder">
                      <div
                        class="photo_section bg-light text-dark"
                        v-for="(video, index) in media_videos"
                        :key="index"
                      >
                        <div class="img_section">
                          <i
                            class="fa fa-file-text-o"
                            style="
                              font-size: 3em;
                              color: #ffbc0d;
                              padding: 30px;
                            "
                          ></i>
                        </div>
                        <b style="word-wrap: break-word; width: 190px">{{
                          video.name
                        }}</b>
                        <span>{{ video.file_size }}</span>
                        <span><b>Created At:</b> {{ video.created_at }}</span>
                      </div>
                    </div>
                  </div>

                  <!-- Files -->
                  <div class="my-5" v-if="media_files.length > 0">
                    <div class="d-flex justify-content-between p-2">
                      Files
                      <button @click="clickMore('Documents')">More</button>
                    </div>
                    <div class="folder">
                      <div
                        class="photo_section bg-light text-dark"
                        v-for="(files, index) in media_files"
                        :key="index"
                      >
                        <div class="img_section">
                          <i
                            class="fa fa-file-text-o"
                            style="
                              font-size: 3em;
                              color: #ffbc0d;
                              padding: 30px;
                            "
                          ></i>
                        </div>
                        <b style="word-wrap: break-word; width: 190px">{{
                          files.name
                        }}</b>
                        <span>{{ files.file_size }}</span>
                        <span><b>Created At:</b> {{ files.created_at }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- modal component -->
    <div>
      <Modal :modalTitle="'Upload Media'" :modalSize="'modal-lg'">
        <div class="card text-dark">
          <div class="card-body">
            <DropFile :folders="allFolders" />
          </div>
        </div>
      </Modal>

      <Modal
        :modalTitle="'Add New Folder'"
        :modalSize="'modal-lg'"
        :id="'addFolder'"
      >
        <div class="card text-dark">
          <div class="card-body">
            <label class="col-form-label">Folder Name</label>
            <input type="text" class="form-control" v-model="folder_name" />

            <button
              class="btn btn-warning mt-2 float-right"
              type="submit"
              @click.prevent="addFolder()"
            >
              Save
            </button>
          </div>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
import titleMixin from "@/mixins/TitleMixins.js";
import DropFile from "../../components/DropFile.vue";
import {
  getRequest,
  postRequest,
  patchRequest,
} from "@/services/RequestService";
import Modal from "@/components/ModalComponent.vue";
import SideBarCard from "../../pages/filemanager/SideBarCard.vue";
import Dropdown from "primevue/dropdown";

export default {
  name: "media-page",
  mixins: [titleMixin],
  components: {
    DropFile,
    Modal,
    SideBarCard,
    Dropdown,
  },

  data() {
    return {
      media_folders: [],
      media_photos: [],
      media_files: [],
      media_videos: [],
      isModalOpen: false,
      folder_name: "",
      isActive: false,
      folder_galleries: [],
      media_folder_cp: [],
      allFolders: [],
      media_photo_cp: [],
      media_files_cp: [],
      media_videos_cp: [],
      searchText: null,
      sortByDate: "desc",
      sortByName: "desc",
      selectedSort: "",
      folderNameInput: "",
      folderToRenameIndex: -1, // Initialize it to -1 or any value that represents no folder selected
    };
  },

  mounted() {
    var folders = this.showFolders(false);
    folders.then((response) => [
      (this.media_folders = response),
      (this.media_folder_cp = response),
    ]);

    var allFolders = this.showFolders(true);
    allFolders.then((response) => [(this.allFolders = response)]);

    var photos = this.showPhotos(false);
    photos.then((response) => [
      (this.media_photos = response),
      (this.media_photo_cp = response),
    ]);

    var files = this.showFiles(false);
    files.then((response) => [
      (this.media_files = response),
      (this.media_files_cp = response),
    ]);

    var videos = this.showVideos(false);
    videos.then((response) => [
      (this.media_videos = response),
      (this.media_videos_cp = response),
    ]);
  },

  methods: {
    uploadBtn() {
      this.isModalOpen = true;
    },

    openRenameModal(index) {
      this.folderToRenameIndex = index;
      this.folderNameInput = this.media_folders[index].name;
    },

    /**** add new folder *****/
    async addFolder() {
      let response = await postRequest("/galleries/folders", {
        name: this.folder_name,
      });

      if (response.data.success) {
        this.$swal({
          icon: response.data.success ? "success" : "error",
          text: response.data.message,
          confirmButtonText: "Close",
        }).then(function () {
          location.reload();
        });
      }
      this.isActive = true;
    },

    async renameFolder(index, newFolderName) {
      if (index >= 0 && index < this.media_folders.length) {
        const folder = this.media_folders[index];

        console.log(folder.id);

        let response = await patchRequest(
          "/galleries/folders/" + folder.id + "/update",
          {
            name: newFolderName,
          }
        );

        if (response.data.success) {
          this.$swal({
            icon: response.data.success ? "success" : "error",
            text: response.data.message,
            confirmButtonText: "Close",
          }).then(function () {
            location.reload();
          });
        }
      }
    },

    /** Get folders API **/
    async showFolders(showAll = true) {
      let response = await getRequest("/galleries/folders");

      if (!showAll) {
        return response.data.data.slice(0, 4);
      } else {
        return response.data.data;
      }
    },

    /** Get photos API **/
    async showPhotos(showAll = true) {
      let response = await getRequest("/galleries");

      if (!showAll) {
        return response.data.data.photos.slice(0, 4);
      } else {
        return response.data.data.photos;
      }
    },

    /** Get files API **/
    async showFiles(showAll = true) {
      let response = await getRequest("/galleries");

      if (!showAll) {
        return response.data.data.files.slice(0, 4);
      } else {
        return response.data.data.files;
      }
    },

    /** Get videos API **/
    async showVideos(showAll = true) {
      let response = await getRequest("/galleries");

      if (!showAll) {
        return response.data.data.videos.slice(0, 4);
      } else {
        return response.data.data.videos;
      }
    },

    /*** Get folder galleries API***/
    async showGalleries(folder_id) {
      let response = await getRequest(
        "/galleries/folders/" + folder_id + "/view"
      );

      return response.data.data;
    },

    // search function
    async handleSearch(event) {
      this.searchText = event.target.value;

      if (this.searchText !== null) {
        let photoResp = await getRequest(
          `/galleries?search=${this.searchText}`
        );
        this.media_photos = photoResp.data.data.photos;

        let folderResp = await getRequest(
          `/galleries/folders?search=${this.searchText}`
        );
        this.media_folders = folderResp.data.data;
      }
    },

    /*** When user click more go to specific tabs**/
    clickMore(type) {
      if (type === "Folders") {
        var folders = this.showFolders(true);
        folders.then((response) => [(this.media_folders = response)]);

        this.media_photos = [];
        this.folder_galleries = [];
        this.media_files = [];
        this.media_videos = [];
      } else if (type === "Photos") {
        var photos = this.showPhotos(true);
        photos.then((response) => [(this.media_photos = response)]);

        this.media_folders = [];
        this.folder_galleries = [];
        this.media_files = [];
        this.media_videos = [];
      } else if (type === "Documents") {
        var files = this.showFiles(true);
        files.then((response) => [(this.media_files = response)]);

        this.folder_galleries = [];
        this.media_folders = [];
        this.media_photos = [];
        this.media_videos = [];
      } else if (type === "Videos") {
        this.folder_galleries = [];
        this.media_folders = [];
        this.media_photos = [];
        this.media_files = [];

        var videos = this.showVideos(true);
        videos.then((response) => [(this.media_videos = response)]);

      } else if (type === "Home") {
        this.folder_galleries = [];
        this.media_folders = [...this.media_folder_cp];
        this.media_photos = [...this.media_photo_cp];
        this.media_files = [...this.media_files_cp];
        this.media_videos = [...this.media_videos_cp];

        // this.folder_galleries = [];
      }
    },

    /*** When user click folder, open to view all photos inside folder **/
    onFolderClick(folder_id) {
      this.media_folders = [];
      this.media_photos = [];
      this.media_files = [];

      var galleries = this.showGalleries(folder_id);

      galleries.then((resp) => [(this.folder_galleries = resp)]);
    },

    async handleSortChange(event) {
      var sort = event.target.value;

      if (sort !== "") {
        // Call your sorting function or update the sort order based on the selected option
        if (this.selectedSort.includes("date")) {
          sort = sort.split(".")[1];
          let photoResp = await getRequest(`/galleries?sortDate=${sort}`);
          this.media_photos = photoResp.data.data.photos;

          let folderResp = await getRequest(
            `/galleries/folders?sortDate=${sort}`
          );
          this.media_folders = folderResp.data.data;
        } else if (this.selectedSort.includes("name")) {
          sort = sort.split(".")[1];
          let photoResp = await getRequest(`/galleries?sortName=${sort}`);
          this.media_photos = photoResp.data.data.photos;

          let folderResp = await getRequest(
            `/galleries/folders?sortName=${sort}`
          );
          this.media_folders = folderResp.data.data;
        }
      }
    },
  },
};
</script>

<style>
#mediaLibrary {
  border-radius: 15px;
}

.mediaBtns {
  display: flex;
  justify-content: flex-end;
}

.addBtn {
  background: #ffbc0d;
}

.addBtn,
.uploadBtn {
  margin: 10px;
  padding: 5px;
  width: 150px;
  border-radius: 10px;
}

.uploadBtn {
  background: lightgray;
}

.upload-media {
  display: flex;
  flex-direction: column;
}

.dropzone {
  background: #f7f7f7 !important;
  border: 2px dashed black !important;
}

#mediaLibrary .fa-plus-circle {
  color: white !important;
}

.uploaded_photos {
  margin: 20px 0;
}

.section-one {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 15px;
}

.folder_icon {
  width: 40px;
}

.folder {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  gap: 20px;
  font-size: 0.8em;
  min-width: 950px;
}

.folder_section {
  padding: 20px;
  min-width: 250px;
  display: flex;
  flex-direction: row;
  gap: 20px;
  border-radius: 10px;
}

.photo_section {
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-radius: 10px;
  width: auto;
}

.files_details {
  color: gray;
}

.photo_icon {
  background: white;
}

.img_section {
  display: flex;
  justify-content: center;
  background-color: white;
}
</style>